import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Alliteams.css";
import Foodcartdata from "./Foodcartdata";
import 'semantic-ui-css/semantic.min.css';
import axios from 'axios';
import Foodandbeveragesadvertise from "../../FoodandBeverages/Foodandbeveragesadvertise";
import allCartsImage from "../../../../images/products/meals.jpg"; // Adjust the path as needed
import { useLoader } from "../../../../context/LoaderProvider.jsx";

const Foodcart = () => {
    const [quantities, setQuantities] = useState({});
    const [filteredItems, setFilteredItems] = useState([]);
    const [cartData, setCartData] = useState([]);
    const [allCategories, setAllCategories] = useState(["Allcarts"]);
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    const [refresh, setRefresh] = useState(false);
    const { showLoader, hideLoader } = useLoader();

    const navigate = useNavigate();
    const isMobile = window.innerWidth <= 768;
    const baseUrl = "https://backend.maamaas.com/food/";

    const [containerWidth, setContainerWidth] = useState(
        window.innerWidth > 1320 ? '180px' : window.innerWidth > 1000 ? '140px' : '100px'
    );

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1320) {
                setContainerWidth('180px');
            } else if (window.innerWidth > 1000) {
                setContainerWidth('140px'); // 👈 smaller width between 1000–1320px
            } else {
                setContainerWidth('100px');
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    // Handle category click
    const handleCategoryClick = (category) => {
        setActiveCategory(category);
        const filtered = category === "Allcarts" ? cartData : cartData.filter(item => item.dishName === category);
        setFilteredItems(filtered);
        setTimeout(() => setRefresh(prev => !prev), 0); // Force re-render
    };

    // Fetch cart data
    useEffect(() => {
        const fetchCartData = async () => {
            const vendorId = localStorage.getItem("vendorId") || "1";
            const token = localStorage.getItem("authToken");

            try {
                showLoader();
                const response = await axios.get(
                    `${baseUrl}api/cart/vendor/${vendorId}`,
                    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
                );

                // Print full response
                console.log("Full API Response:", response);

                const items = response.data.cartItems || [];

                // Print cart items array
                console.log("Cart Items from backend:", items);

                // Print each item's dish name and image
                items.forEach(item => {
                    console.log("Dish Name:", item.dishName, "Dish Image:", item.dishImage);
                });

                setCartData(items);
                setFilteredItems(items);

                const categories = [...new Set(items.map(item => item.dishName))];
                setAllCategories(["Allcarts", ...categories]);

                // Quantities
                const savedQuantities = JSON.parse(localStorage.getItem("cartQuantities") || "{}");
                const updatedQuantities = {};
                items.forEach((item) => {
                    const dishId = item.itemId || item.dishId || item.id;
                    updatedQuantities[dishId] = item.quantity ?? item.qty ?? savedQuantities[dishId] ?? 1;
                });
                setQuantities(updatedQuantities);
                localStorage.setItem("cartQuantities", JSON.stringify(updatedQuantities));

            } catch (error) {
                console.error("Error fetching cart data:", error);
            } finally {
                hideLoader();
            }
        };

        fetchCartData();
    }, [refresh]);
    // Refetch if refresh changes

    // Update filteredItems when activeCategory or cartData changes
    useEffect(() => {
        const filtered = activeCategory === "Allcarts" ? cartData : cartData.filter(item => item.dishName === activeCategory);
        setFilteredItems(filtered);
    }, [activeCategory, cartData]);

    return (
        <div className="container-fluid">
            <div className="row" style={{ marginTop: "50px" }}>
                {/* Category Sidebar */}
                <div className="col-lg-2 col-md-3 col-sm-3 col-3">
                    <div
                        className="category-sidebar d-none d-sm-block mobile-scrolling-cart"
                        style={{
                            maxHeight: "600px",
                            position: "sticky",
                            top: 0,
                            marginTop: "5px",
                            zIndex: 1000,
                            width: containerWidth,
                        }}
                    >
                        <div className="category-container" style={{ overflowY: "auto", height: "556px", marginTop: "68px" }}>
                            {allCategories.map((category, index) => {
                                const item = cartData.find(i => i.dishName === category);
                                const categoryImage =
                                    category === "Allcarts"
                                        ? allCartsImage
                                        : item?.dishImage
                                            ? `${baseUrl}${item.dishImage}`
                                            : "/placeholder.svg";


                                return (
                                    <div
                                        key={index}
                                        className="category-card"
                                        onClick={() => handleCategoryClick(category)}
                                        style={{
                                            backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                            margin: "8px 0",
                                            padding: "10px",
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            cursor: "pointer",
                                            justifyContent: "center",
                                            borderRadius: "15px",
                                            transition: "0.3s ease-in-out",
                                            boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                            height: "165px",
                                        }}
                                    >
                                        <img
                                            src={categoryImage}
                                            alt={category}
                                            style={{
                                                width: "100px",
                                                height: "100px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                            }}
                                            onError={(e) => { e.target.src = allCartsImage; }} // fallback if broken
                                        />


                                        <div className="category-card-body d-flex justify-content-center p-0">
                                            <button
                                                style={{
                                                    backgroundColor: activeCategory === category ? "#ddd" : "#fff",
                                                    margin: "5px",
                                                    padding: "8px",
                                                    borderRadius: "10px",
                                                    cursor: "pointer",
                                                    transition: "0.3s ease-in-out",
                                                }}
                                            >
                                                {category}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                    </div>

                    {/* Mobile Dropdown */}
                    <div className="d-block d-sm-none" style={{ marginTop: "65px", width: "100%" }}>
                        <select
                            className="form-control cart-drop-data"
                            onChange={(e) => handleCategoryClick(e.target.value)}
                            value={activeCategory}
                            style={{
                                padding: "8px",
                                borderRadius: "10px",
                                border: "1px solid #ccc",
                                width: "100%",
                                background: "#b15dc6",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "20px",
                            }}
                        >
                            {allCategories.map((category, index) => (
                                <option key={index} value={category}>
                                    {category}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Main Content */}
                <div className="col-lg-7 col-md-7 col-sm-12 col-12">
                    {/* Breadcrumb */}
                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                            top: isMobile ? "50px" : "80px",
                            left: isMobile ? "5px" : "18vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                            padding: "10px 0",
                            fontSize: isMobile ? "14px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        {/* <Link to="/Newmainlandingpage" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            Home
                        </Link>
                        <span className="separator"> &gt; </span> */}
                        <Link to="/foodladingpage" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            Food & Beverages
                        </Link>
                        <span className="separator"> &gt; </span>
                        <Link to="/menuiteams" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            Menu_Management
                        </Link>
                        <span className="separator"> &gt; </span>
                        <Link to="/foodcart" style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                            Cart
                        </Link>
                    </p>

                    {/* Cart Items */}
                    <div className="cartsizes" style={{ marginTop: "100px", padding: "20px", borderRadius: "8px" }}>
                        <Foodcartdata key={activeCategory} filteredDataProp={filteredItems} />
                    </div>

                    {/* Advertise */}
                    <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                        <Foodandbeveragesadvertise />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Foodcart;
